import React from 'react';

export function LoadingScreen() {
  return (
    <div className="flex flex-col items-center min-h-screen bg-gray-50 dark:bg-gray-900 p-4 pt-20">
      <div className="w-full max-w-lg space-y-4">
        {/* Skeleton para las métricas */}
        <div className="space-y-3">
          <div className="h-24 bg-white dark:bg-gray-800 rounded-lg shadow-sm dark:shadow-gray-700/10 overflow-hidden relative">
            <div className="absolute inset-0">
              <div className="w-full h-full bg-gradient-to-r from-transparent via-gray-200 dark:via-gray-700 to-transparent translate-x-[-100%] animate-shimmer" />
            </div>
          </div>
          <div className="h-24 bg-white dark:bg-gray-800 rounded-lg shadow-sm dark:shadow-gray-700/10 overflow-hidden relative">
            <div className="absolute inset-0">
              <div className="w-full h-full bg-gradient-to-r from-transparent via-gray-200 dark:via-gray-700 to-transparent translate-x-[-100%] animate-shimmer" />
            </div>
          </div>
        </div>
        
        {/* Skeleton para el gráfico */}
        <div className="h-48 bg-white dark:bg-gray-800 rounded-lg shadow-sm dark:shadow-gray-700/10 overflow-hidden relative">
          <div className="absolute inset-0">
            <div className="w-full h-full bg-gradient-to-r from-transparent via-gray-200 dark:via-gray-700 to-transparent translate-x-[-100%] animate-shimmer" />
          </div>
        </div>
      </div>
    </div>
  );
} 